import React from 'react';
import FeedSearchInput from './FeedSearchInput';
import AppSelect from '../../../components/AppSelect';

const BookmarkIcon = ({ active }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-[6px]">
        <path
            d="M8.6 11.45L10.72 13.04C11.2474 13.4355 12 13.0592 12 12.4V4.5C12 3.39543 11.1046 2.5 10 2.5H6C4.89543 2.5 4 3.39543 4 4.5V12.4C4 13.0592 4.75261 13.4355 5.28 13.04L7.4 11.45C7.75556 11.1833 8.24444 11.1833 8.6 11.45Z"
            stroke={active ? '#4F46E5' : '#636369'}
            fill={active ? '#4F46E5' : 'none'}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const UnreadDotIcon = ({ active }) => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-[6px]">
        <circle cx="4" cy="4" r="4" fill={active ? "#4F46E5" : "#C5C5C7"} />
    </svg>
);

const SORT_OPTIONS_WITH_QUERY = [
    { value: 'relevance', label: 'Liên quan' },
    { value: 'newest', label: 'Mới nhất' },
    { value: 'oldest', label: 'Cũ nhất' },
];

const PERIOD_OPTIONS = [
    { value: 'all', label: 'Thời gian' },
    { value: 'today', label: 'Hôm nay' },
    { value: '7d', label: '7 ngày' },
    { value: '30d', label: '30 ngày' },
];

const SCOPE_OPTIONS = [
    { value: 'all', label: 'Phạm vi' },
    { value: 'watchlist', label: 'Đang theo dõi' },
    { value: 'portfolio', label: 'Danh mục' },
];

const CONTROL_HEIGHT = 'h-[32px]';

function ActionPill({ active, onClick, icon: Icon, children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`inline-flex items-center w-full ${CONTROL_HEIGHT} px-[12px] rounded-[16px] border text-[14px] transition-all whitespace-nowrap ${active
                ? 'bg-[#EEF2FF] border-[#C7D2FE] text-[#4F46E5]'
                : 'bg-white border-[#ECECED] text-[#111827] hover:border-[#D1D5DB]'
                }`}
        >
            {Icon && <Icon active={active} />}
            {children}
        </button>
    );
}

export default function FeedFilterBar({
    query, onSubmit, onSelectSymbol, onSelectInsight,
    period, onPeriod,
    categories, category, onCategory,
    scope, onScope,
    unreadOnly, onToggleUnread,
    savedOnly, onToggleSaved,
    hideSearch = false,
}) {
    return (
        <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-[8px] w-full">
            {!hideSearch && (
                <div className="w-full lg:w-[193px] shrink-0">
                    <FeedSearchInput
                        value={query}
                        onSubmit={onSubmit}
                        onSelectSymbol={onSelectSymbol}
                        onSelectInsight={onSelectInsight}
                    />
                </div>
            )}

            <div className={`flex flex-row items-center justify-between flex-1 gap-[8px]`}>
                <div className='flex flex-row gap-[8px]'>
                    <AppSelect
                        value={category || ''}
                        onChange={onCategory}
                        className={hideSearch ? '' :"max-w-[124px]"}
                        dropdownWidth="auto"
                        options={[
                            { value: '', label: 'Loại báo cáo' },
                            ...(categories || []).map((c) => ({ value: c.code, label: c.display_name || c.code }))
                        ]}
                    />
    
                    <AppSelect
                        value={period || 'all'}
                        onChange={onPeriod}
                        className={hideSearch ? '' :"max-w-[118px]"}
                        dropdownWidth="auto"
                        options={PERIOD_OPTIONS}
                    />
    
                    <AppSelect
                        value={scope || 'all'}
                        onChange={onScope}
                        className={hideSearch ? '' :"max-w-[118px]"}
                        dropdownWidth="auto"
                        options={SCOPE_OPTIONS}
                    />
                </div>

                <div className="flex items-center gap-[8px]">
                    <ActionPill active={unreadOnly} onClick={onToggleUnread} icon={UnreadDotIcon}>
                        Chưa đọc
                    </ActionPill>
                    <ActionPill active={savedOnly} onClick={onToggleSaved} icon={BookmarkIcon}>
                        Đã lưu
                    </ActionPill>
                </div>
            </div>
        </div>
    );
}
